module.exports = __webpack_public_path__ + "img/sintesis.11dd12d9.svg";